module.exports = __webpack_public_path__ + "img/snapchat.34715fad.svg";